var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
//import i18n from '../i18n';
import "react-toastify/dist/ReactToastify.css";
import LocalStorageService from "./local-storage-service";
import { toast } from "react-toastify";
import AuthApi from "./api/auth/auth-api";
import { clearAllFilterMemory } from "./filter-memory-storage";
const baseURL = process.env.REACT_APP_API_BASE_URL;
let refreshing_token = null;
const shouldSkipAuthHeader = (url) => {
    if (!url)
        return false;
    return (url.includes("token/refreshToken") ||
        url.includes("account/authenticate") ||
        url.includes("account/ad-user-login"));
};
export const http_api = axios.create({
    baseURL: baseURL,
    headers: {
        "Content-Type": "application/json",
    },
});
http_api.interceptors.request.use((config) => __awaiter(void 0, void 0, void 0, function* () {
    if (LocalStorageService.getAccessToken() != null) {
        if (!shouldSkipAuthHeader(config.url)) {
            if (config.headers)
                config.headers.set("Authorization", `Bearer ${LocalStorageService.getAccessToken()}`);
        }
    }
    return config;
}));
http_api.interceptors.response.use((response) => {
    return response;
}, (error) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const config = error.config;
    if (error.response &&
        error.response.status === 401 &&
        config &&
        !config._retry) {
        if (shouldSkipAuthHeader((_a = error.config) === null || _a === void 0 ? void 0 : _a.url)) {
            return Promise.reject(error);
        }
        config._retry = true;
        try {
            refreshing_token = refreshing_token ? refreshing_token : refresh_token();
            yield refreshing_token;
            refreshing_token = null;
            return http_api(config);
        }
        catch (err) {
            refreshing_token = null;
            LocalStorageService.removeAccessToken();
            LocalStorageService.removeRefreshToken();
            // Session ended involuntarily — drop the saved list filters too (item #2),
            // so whoever signs in next on this tab starts from the defaults.
            clearAllFilterMemory();
            window.location.href = "/";
            return Promise.reject(err);
        }
    }
    else if (error.response && error.response.status === 403) {
        toast.error("Niet geautoriseerd om deze bewerking uit te voeren");
        return Promise.reject(error);
    }
    return Promise.reject(error);
}));
function refresh_token() {
    return __awaiter(this, void 0, void 0, function* () {
        const input = {
            accessToken: LocalStorageService.getAccessToken(),
            refreshToken: LocalStorageService.getRefreshToken(),
        };
        return yield AuthApi.getRefreshToken(input).then((response) => {
            LocalStorageService.setAccessToken(response.data.accessToken);
            LocalStorageService.setRefreshToken(response.data.refreshToken);
        });
    });
}
